import React from 'react';
import { Heart, Users, Award } from 'lucide-react';
import { S3_IMAGES } from '../config/s3Images';

/** About Us banner: same as ticket main pic (per Website Information PDF) */
const aboutusimg = S3_IMAGES.TICKET_MAIN;

export default function AboutUs() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#faf8f5' }}>
      {/* Title Section - Mobile Optimized */}
      <div className="text-center animate-fade-in">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 pb-3 sm:pb-4">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">About us!</h1>
        </div>
      </div>

      {/* Hero Section with Team Photo - Mobile Optimized */}
      <section className="mx-auto px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8 animate-fade-in" style={{ animationDelay: '0.2s' }}>
        <div className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-xl sm:shadow-2xl">
          <img 
            src={aboutusimg} 
            alt="AFTH Team 2025" 
            className="w-full h-[300px] sm:h-[400px] md:h-[600px] lg:h-[800px] object-cover"
          />
        </div>

        {/* Main Content - Mobile Optimized */}
        <div className="mt-8 sm:mt-12 md:mt-16 lg:mt-20 text-center max-w-4xl mx-auto px-4 animate-fade-in" style={{ animationDelay: '0.4s' }}>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-3 sm:mb-4">
            NTU CAC Arts From The Heart (AFTH) is a <span className="font-semibold text-gray-900">special project</span> under NTU CAC.
          </p>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed mb-3 sm:mb-4">
            Since its inception in 2004, AFTH has consistently poured love into its mission of supporting <span className="font-semibold text-gray-900">diverse charitable organisations</span>. Our club has touched the lives of over 7,000 participants and built heartwarming partnerships with <span className="font-semibold text-gray-900">over 400 sponsors</span>.
          </p>
        </div>

        {/* Stats Cards - Mobile Optimized */}
        <div className="mt-8 sm:mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 max-w-5xl mx-auto px-4 animate-fade-in" style={{ animationDelay: '0.6s' }}>
          <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 text-center transform hover:scale-105 transition sm:col-span-2 md:col-span-1">
            <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-blue-100 rounded-full mb-3 sm:mb-4">
              <Heart className="w-7 h-7 sm:w-8 sm:h-8 text-blue-600" />
            </div>
            <div className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">20+ Years</div>
            <div className="text-sm sm:text-base text-gray-600">Since 2004</div>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 text-center transform hover:scale-105 transition">
            <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-purple-100 rounded-full mb-3 sm:mb-4">
              <Users className="w-7 h-7 sm:w-8 sm:h-8 text-purple-600" />
            </div>
            <div className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">7,000+</div>
            <div className="text-sm sm:text-base text-gray-600">Participants Impacted</div>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 text-center transform hover:scale-105 transition">
            <div className="inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-pink-100 rounded-full mb-3 sm:mb-4">
              <Award className="w-7 h-7 sm:w-8 sm:h-8 text-pink-600" />
            </div>
            <div className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">400+</div>
            <div className="text-sm sm:text-base text-gray-600">Sponsor Partnerships</div>
          </div>
        </div>
      </section>

      {/* CSS Animations */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out both;
        }

        /* Disable hover effects on mobile */
        @media (hover: none) {
          .hover\\:scale-105:hover {
            transform: none;
          }
        }
      `}</style>
    </div>
  );
}